import Box from 'app/components/base/Box'
import Container from 'app/components/base/Container'

const gradient = (percent: string): string =>
  `radial-gradient(${percent} 86.76% at 50% 115%, rgba(75, 255, 186, 0.4) 0%, rgba(0, 31, 200, 0) 100%), linear-gradient(180deg, #101340 0%, #102262 100%)`

interface StoreHeaderContainerProps {
  isBusinessUser?: boolean
}

const StoreHeaderContainer: RFC<StoreHeaderContainerProps> = ({
  isBusinessUser,
  children
}) => {
  if (isBusinessUser) {
    return (
      <Container maxWidth="lg" sx={{ mt: 1, mb: { md: 4, xs: 2 } }}>
        {children}
      </Container>
    )
  }

  return (
    <Box
      sx={{
        background: {
          xs: gradient('45%'),
          sm: gradient('40%'),
          md: gradient('35%'),
          lg: gradient('30%')
        }
      }}
    >
      <Container
        maxWidth="lg"
        sx={{ mt: { md: 4.5, xs: 4 }, mb: { md: 4.5, xs: 2 } }}
      >
        {children}
      </Container>
    </Box>
  )
}

export default StoreHeaderContainer
